module.exports = __webpack_public_path__ + "static/media/datatour-original.d8616ae1.jpg";